var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaticEmbedding = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3.75,
  y: 3.75,
  width: 112.5,
  height: 88.5,
  rx: 8.25,
  stroke: "#F1F1F1",
  strokeWidth: 7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M42 57h27v27H48a6 6 0 0 1-6-6V57ZM75 57h30v21a6 6 0 0 1-6 6H75V57ZM42 36a6 6 0 0 1 6-6h51a6 6 0 0 1 6 6v15H42V36Z",
  fill: "#D0D0D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 18a6 6 0 0 1 6-6h78a6 6 0 0 1 6 6v6H15v-6ZM15 30h18v54H21a6 6 0 0 1-6-6V30Z",
  fill: "#F1F1F1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v96H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaticEmbedding);
export default ForwardRef;